export enum StorageKeyContext {
    INDIVIDUAL = 'individual',
    SHARED = 'shared',
}

export interface IStorageKey {
    getValue(): string;
}
